// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2-Bpu","label":"SetPasswdForm_label__3D2FE"};